import React from "react";
import { Form, Select, Input, InputNumber, Upload, message,DatePicker,Row,Col } from 'antd';
import TitleTop from '@pages/Assembly/titleTop';
import { Flex } from '@components';
import NHFormItem from '@components/common/NHFormItem/index';
import NHCascader from "@components/common/NHCascader";
import NHSelect from '@components/common/NHSelect';
import { createUuid } from '@utils/NHCore';
import NHFetch from '@utils/NHFetch';
import classNames from 'classnames';
import * as moment from 'moment';
import './index.css';

const uploadUrl = "api/zhxg-yxwz/newStudent/cacheStudentPhoto"; //上传logo路径
const getPicUrl = "api/zhxg-yxwz/newStudent/getStudentPhoto";//获取图片路径
import { getLoginUser } from "@utils/NHCore";

const { RangePicker } = DatePicker;

function beforeUpload(file) {

    const isJPG = file.type === "image/jpeg" || file.type === "image/png";
    if (!isJPG) {
        message.error("You can only upload JPG file!");
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
        message.error("Image must smaller than 2MB!");
    }
    return isJPG && isLt2M;
}

class JbxxInitForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            jbxx: false,
            xsid: '',
            userInfoData: null,
            zzmmmList: [],
            mzmList: [],
            textData: '',
            jgmStr: '',
            jtszdqStr:'',
            jtStr: '',
            xsSsInfo: '',
            formInitData:{
            }
        }
    }

    componentDidMount() {
        let userId = getLoginUser() ? getLoginUser().userId : undefined;
        if (userId) {
            this.setState({
                xsid: userId,
                tempUrl: <img src={getPicUrl + '?xsid=' + userId + '&type=' + '10' + '&uuid=' + createUuid()} alt="" className="avatar" />
            });
        }
        NHFetch('/newStudent/queryStuCollectBaseInfo','GET',{xsid:userId}).then(res=>{
            if (res && res.code == 200 && res.data) {
                let formInitData = {...res.data};
                const { jgm, sfzyxqksrq,sfzyxqjsrq } = res.data.jbxx;
                formInitData.jbxx = {...res.data.jbxx,jgmArray:this.getCasderArray(jgm),sfzyxq:[sfzyxqksrq?moment(sfzyxqksrq):undefined,sfzyxqjsrq?moment(sfzyxqjsrq):undefined]}
                const {jtszdq,jtdh} =( res.data.jtxx || {});
                let jtdhqh,jtdhhm;
                if (jtdh) {
                    let qhhm = jtdh.split('-')
                    if (qhhm.length > 1) {
                        jtdhqh = qhhm[0];
                        jtdhhm = qhhm[1];
                    } else {
                        jtdhhm = jtdh;
                    }
                }
                formInitData.jtxx = {...res.data.jtxx,jtszdqArray:this.getCasderArray(jtszdq),jtdhhm,jtdhqh}
                let jgmStr = formInitData.jbxxView ? formInitData.jbxxView.JG : '';
                let jtszdqStr = formInitData.jbxxView ? formInitData.jbxxView.jtszdqStr : '';
                this.setState({formInitData,jgmStr,jtszdqStr})
            }
        })
    }

    getCasderArray = (str)=>{
        if (str) {
            switch (str.length) {
                case 2:
                    return [str];
                case 4:
                    return [str.substring(0,2),str.substring(0,4)];
                case 6:
                    return [str.substring(0,2),str.substring(0,4),str.substring(0,6)];
                default:
                    return [];
            }
        }
        return []
    }


    onSavejbxxFormData = (cb) => {
        this.props.form.validateFields((error, values) => {
            if (error) {
                cb(false);
                return;
            }
            values.jbxx.pkid = this.state.xsid;
            if (Array.isArray(values.jbxx.jgmArray)) {
                values.jbxx.jgm = values.jbxx.jgmArray[values.jbxx.jgmArray.length - 1];
            }
            if (Array.isArray(values.jtxx.jtszdqArray)) {
                values.jtxx.jtszdq = values.jtxx.jtszdqArray[values.jtxx.jtszdqArray.length - 1];
            }
            if (values.jtxx.jtdhqh) {
                values.jtxx.jtdh = `${values.jtxx.jtdhqh}-${values.jtxx.jtdhhm}`
            } else {
                values.jtxx.jtdh =values.jtxx.jtdhhm
            }
            if (Array.isArray(values.jbxx.sfzyxq)) {
                values.jbxx.sfzyxqksrq = values.jbxx.sfzyxq[0].valueOf();
                values.jbxx.sfzyxqjsrq = values.jbxx.sfzyxq[1].valueOf();
            }
            NHFetch('/newStudent/updateStuCollectBaseInfo','POST',values).then(res=>{
                if (res && res.code === 200 && res.data) {
                    message.success(res.message);
                    let jbxxView = {...this.state.formInitData.jbxxView};
                    jbxxView.JG = this.state.jgmStr;
                    jbxxView.jtszdqStr = this.state.jtszdqStr;
                    this.setState({jbxx:false,formInitData:{...this.state.formInitData,...values,jbxxView}})
                    this.props.updateBlzt()
                    this.props.cacheFormData('jbxx', values);
                    cb(true);
                } else {
                    cb(false)
                }
            })
        });

    }

    getBase64(img, callback) {
        const reader = new FileReader();
        reader.addEventListener('load', () => callback(reader.result));
        reader.readAsDataURL(img);
    }
    // 上传图片
    handleUploadChange = info => {
        let userId = getLoginUser() ? getLoginUser().userId : undefined;
        if (info && info['file'] && info['file'].status === 'done') {
            let photoUUID = info['file'].response.data;
            if (photoUUID) {
                let url = '/newStudent/saveStudentPhoto?xsid=' + userId + '&photoUUID=' + photoUUID + '&type=' + '10';
                NHFetch(url, 'POST')
                    .then(res => {
                        if (res && res.data) {
                            message.success("上传成功!")
                        }
                    });
            }
        }
        this.getBase64(info.file.originFileObj, imageUrl =>
            this.setState({ imageUrl })
        );
    }

    onNHCascaderChange = (value, selectedOptions, type) => {
        let label = '';
        if (selectedOptions) {
            selectedOptions.forEach((i) => {
                label += i.label;
            });
        }
        if (type == 'jg') {
            this.setState({ jgmStr: label });
        } else {
            this.setState({ jtszdqStr: label });
        }

    }

    /** 验证必填项 */
    validateCustom = () => {
        const { edit, formInitData } = this.state;
        if(edit) {
            // 若是编辑模式 使用表单验证
            this.props.form.validateFields((err,values) => {
                if(err) {
                    return false
                }
                return true
            })
        } else {
            return true
        }
    }

    render() {
        const { form, jbxxFormData, getChildComponent, userInfoData, stuSsxx, editXszp } = this.props;
        const { jbxx, imageUrl, tempUrl, xsid,formInitData } = this.state;
        const jtjddz = jbxxFormData ? jbxxFormData.jtjddz : '';
        const jtdzDetail = jbxxFormData ? jbxxFormData.jtdzDetail : '';
        let ssxx = '';
        if (stuSsxx && stuSsxx.xqmc && stuSsxx.ldmc && stuSsxx.fj && stuSsxx.cwh) {
            ssxx = stuSsxx.xqmc + stuSsxx.ldmc + ' - ' + stuSsxx.fj + ' - ' + stuSsxx.cwh;
        }
        const renderView = ()=> {
            return (
                <React.Fragment>

                    <Flex className="p-sw">
                        <div styleName="jbxx_icon" className="_bg">
                            {
                                imageUrl ?
                                    <img
                                        src={imageUrl}
                                        alt=""
                                        className="avatar"
                                    />
                                    :
                                    tempUrl
                            }

                        </div>
                        <Flex.Item className="ml-20">
                            <div styleName="jbxx_item">
                                <span styleName="item-label">姓名：</span>
                                <div
                                    className="t-clamp-1"
                                    styleName="item-name"
                                    style={{ display: 'inline' }}
                                >
                                    {formInitData.jbxxView?formInitData.jbxxView.XM:''}

                                    {
                                        formInitData.jbxxView && formInitData.jbxxView.XB ?

                                            formInitData.jbxxView && formInitData.jbxxView.XB === '男' ?
                                                <img src={require('@images/boy.png')} alt="" />
                                                : formInitData.jbxxView && formInitData.jbxxView.XB === '女' ?
                                                    <img src={require('@images/girl.png')} alt="" />
                                                    :
                                                    <img src={require('@images/weizhixb.png')} alt="" />
                                            : ''

                                    }

                                </div>
                            </div>
                            <div styleName="jbxx_item">
                                <span styleName="item-label">学号：</span>
                                <div
                                    className="t-clamp-1"
                                    styleName="item-name"
                                    style={{ display: 'inline' }}
                                >
                                    {formInitData.jbxxView?formInitData.jbxxView.XH:''}
                                </div>
                            </div>
                            <div styleName="jbxx_item">
                                <span styleName="item-label">性别：</span>
                                <div
                                    className="t-clamp-1"
                                    styleName="item-name"
                                    style={{ display: 'inline' }}
                                >
                                    {formInitData.jbxxView?formInitData.jbxxView.XB:''}
                                </div>
                            </div>
                            <div styleName="jbxx_item2">
                                <span styleName="item-label">曾用名：</span>
                                <div
                                    className="t-clamp-1"
                                    styleName="item-name"
                                    style={{ display: 'inline' }}
                                >
                                    {formInitData.kzxx ? formInitData.kzxx.cym : ''}
                                </div>
                            </div>
                            <div styleName="jbxx_item">
                                <span styleName="item-label">民族：</span>
                                <div
                                    className="t-clamp-1"
                                    styleName="item-name"
                                    style={{ display: 'inline' }}
                                >
                                    {formInitData.jbxxView ? formInitData.jbxxView.MZ : ''}
                                </div>
                            </div>
                            <div styleName="jbxx_item">
                                <span styleName="item-label">政治面貌：</span>
                                <div
                                    className="t-clamp-1"
                                    styleName="item-name"
                                    style={{ display: 'inline' }}
                                >
                                    {formInitData.jbxxView ? formInitData.jbxxView.ZZMM : ''}
                                </div>
                            </div>
                            <div styleName="jbxx_item">
                                <span styleName="item-label">籍贯：</span>
                                <div
                                    className="t-clamp-1"
                                    styleName="item-name"
                                    style={{ display: 'inline' }}
                                >
                                    {formInitData.jbxxView ? formInitData.jbxxView.JG : ''}
                                </div>
                            </div>
                            <div styleName="jbxx_item">
                                <span styleName="item-label">学院：</span>
                                <div
                                    className="t-clamp-1"
                                    styleName="item-name"
                                    style={{ display: 'inline' }}
                                >
                                    {formInitData.jbxxView ? formInitData.jbxxView.BMMC : ''}
                                </div>
                            </div>
                            <div styleName="jbxx_item">
                                <span styleName="item-label">专业：</span>
                                <div
                                    className="t-clamp-1"
                                    styleName="item-name"
                                    style={{ display: 'inline' }}
                                >
                                    {formInitData.jbxxView ? formInitData.jbxxView.ZYMC : ''}
                                </div>
                            </div>
                            <div styleName="jbxx_item">
                                <span styleName="item-label">班级：</span>
                                <div
                                    className="t-clamp-1"
                                    styleName="item-name"
                                    style={{ display: 'inline' }}
                                >
                                    {formInitData.jbxxView ? formInitData.jbxxView.BJMC : ''}
                                </div>
                            </div>
                            <div styleName="jbxx_item">
                                <span styleName="item-label">身高：</span>
                                <div
                                    className="t-clamp-1"
                                    styleName="item-name"
                                    style={{ display: 'inline' }}
                                >
                                    {formInitData.tjxx ? `${formInitData.tjxx.sg}cm` : ''}
                                </div>
                            </div>
                            <div styleName="jbxx_item2">
                                <span styleName="item-label">本人电话：</span>
                                <div
                                    className="t-clamp-1"
                                    styleName="item-name"
                                    style={{ display: 'inline' }}
                                >
                                    {formInitData.lxxx ? formInitData.lxxx.sjhm : ''}
                                </div>
                            </div>
                        </Flex.Item>
                    </Flex>
                    <div className="p-sw">
                        <div styleName="jbxx_item2">
                            <span styleName="item-label">家庭电话：</span>
                            <div
                                className="t-clamp-1"
                                styleName="item-name"
                                style={{ display: 'inline' }}
                            >
                                {formInitData.jtxx ? formInitData.jtxx.jtdh : ''}
                            </div>
                        </div>
                        <div styleName="jbxx_item2">
                            <span styleName="item-label">E-mail：</span>
                            <div
                                className="t-clamp-1"
                                styleName="item-name"
                                style={{ display: 'inline' }}
                            >
                                {formInitData.lxxx ? formInitData.lxxx.dzyx : ''}
                            </div>
                        </div>
                        <div styleName="jbxx_item2">
                            <span styleName="item-label">微信号：</span>
                            <div
                                className="t-clamp-1"
                                styleName="item-name"
                                style={{ display: 'inline' }}
                            >
                                {formInitData.lxxx ? formInitData.lxxx.wx : ''}
                            </div>
                        </div>
                        <div styleName="jbxx_item2">
                            <span styleName="item-label">QQ号：</span>
                            <div
                                className="t-clamp-1"
                                styleName="item-name"
                                style={{ display: 'inline' }}
                            >
                                {formInitData.lxxx ? formInitData.lxxx.qq : ''}
                            </div>
                        </div>
                        <div styleName="jbxx_item2">
                            <span styleName="item-label">身份证件号：</span>
                            <div
                                className="t-clamp-1"
                                styleName="item-name"
                                style={{ display: 'inline' }}
                            >
                                {formInitData.jbxxView ? formInitData.jbxxView.SFZJH : ''}
                            </div>
                        </div>
                        <div styleName={classNames({'jbxx_item2':!jbxx})}>
                            <span styleName="item-label">身份证签发机关：</span>
                            <div
                                className="t-clamp-1"
                                styleName="item-name"
                                style={{ display: 'inline' }}
                            >
                                {formInitData.jbxx ? formInitData.jbxx.sfzqfjg : ''}
                            </div>
                        </div>
                        <div styleName={classNames({'jbxx_item2':!jbxx})}>
                            <span styleName="item-label">身份证有效期：</span>
                            <div
                                className="t-clamp-1"
                                styleName="item-name"
                                style={{ display: 'inline' }}
                            >
                                {formInitData.jbxx && formInitData.jbxx.sfzyxqksrq && formInitData.jbxx.sfzyxqjsrq ? `${moment(formInitData.jbxx.sfzyxqksrq).format('YYYY-MM-DD')}~${moment(formInitData.jbxx.sfzyxqjsrq).format('YYYY-MM-DD')}` : ''}
                            </div>
                        </div>
                        <div styleName={classNames({'jbxx_item2':!jbxx})}>
                            <span styleName="item-label">身份证住址：</span>
                            <div
                                className="t-clamp-1"
                                styleName="item-name"
                                style={{ display: 'inline' }}
                            >
                                {formInitData.jbxx ? formInitData.jbxx.sfzzz : ''}
                            </div>
                        </div>
                        <div>
                            <span styleName="item-label" style={{ lineHeight: '32px' }}>家庭住址：</span>
                            <div
                                className="t-clamp-1"
                                styleName="item-name"
                                style={{ display: 'inline' }}
                            >
                                {formInitData.jbxxView ? formInitData.jbxxView.jtszdqStr : ''}{formInitData.jtxx ? formInitData.jtxx.jtjddz : ''}
                            </div>
                        </div>
                        <div styleName={classNames({'jbxx_item2':!jbxx})}>
                            <span styleName="item-label">爱好/特长：</span>
                            <div
                                className="t-clamp-1"
                                styleName="item-name"
                                style={{ display: 'inline' }}
                            >
                                {formInitData.kzxx ? formInitData.kzxx.grtc : ''}
                            </div>
                        </div>
                    </div>
                </React.Fragment>
            );
        }
        const renderEdit = () => {
            const formItemLayout = {
                labelCol: {
                  xs: { span: 24 },
                  sm: { span: 8 },
                },
                wrapperCol: {
                  xs: { span: 24 },
                  sm: { span: 16 },
                },
              };
            const { getFieldDecorator } = this.props.form;
            return (
                <React.Fragment>
                    <Flex className="p-sw">
                    <div styleName="jbxx_icon" className="_bg">
                        {editXszp === "true" ?
                            <Upload
                                name="photo"
                                accept={'image/*'}
                                showUploadList={false}
                                action={uploadUrl + "?xsid=" + xsid}
                                beforeUpload={beforeUpload}
                                onChange={this.handleUploadChange}
                            >
                                {imageUrl || userInfoData ? (
                                    imageUrl ?

                                        <img
                                            src={imageUrl}
                                            alt=""
                                            className="avatar"
                                        />
                                        : tempUrl
                                ) : (
                                        <div styleName="upload-box">
                                            <div styleName="upload-title">
                                                上传图片
                                        </div>
                                        </div>
                                    )}
                            </Upload>
                            :
                            imageUrl ?
                                <img
                                    src={imageUrl}
                                    alt=""
                                    className="avatar"
                                />
                                :
                                tempUrl

                        }

                    </div>
                    <Flex.Item className="ml-20">
                        <div>
                            <span styleName="item-label">姓名：</span>
                            <div
                                className="t-clamp-1"
                                styleName="item-name"
                                style={{ display: 'inline' }}
                            >
                                {formInitData.jbxxView?formInitData.jbxxView.XM:''}

                                {
                                    formInitData.jbxxView && formInitData.jbxxView.XB ?

                                        formInitData.jbxxView && formInitData.jbxxView.XB === '男' ?
                                            <img src={require('@images/boy.png')} alt="" />
                                            : formInitData.jbxxView && formInitData.jbxxView.XB === '女' ?
                                                <img src={require('@images/girl.png')} alt="" />
                                                :
                                                <img src={require('@images/weizhixb.png')} alt="" />
                                        : ''

                                }

                            </div>
                        </div>
                        <div>
                            <span styleName="item-label">学号：</span>
                            <div
                                className="t-clamp-1"
                                styleName="item-name"
                                style={{ display: 'inline' }}
                            >
                                {formInitData.jbxxView ? formInitData.jbxxView.XH : ''}
                            </div>
                        </div>
                        <div>
                            <span styleName="item-label">性别：</span>
                            <div
                                className="t-clamp-1"
                                styleName="item-name"
                                style={{ display: 'inline' }}
                            >
                                {formInitData.jbxxView ? formInitData.jbxxView.XB : ''}
                            </div>
                        </div>
                        
                        <div>
                            <span styleName="item-label">学院：</span>
                            <div
                                className="t-clamp-1"
                                styleName="item-name"
                                style={{ display: 'inline' }}
                            >
                                {formInitData.jbxxView ? formInitData.jbxxView.BMMC : ''}
                            </div>
                        </div>
                        <div>
                            <span styleName="item-label">专业：</span>
                            <div
                                className="t-clamp-1"
                                styleName="item-name"
                                style={{ display: 'inline' }}
                            >
                                {formInitData.jbxxView ? formInitData.jbxxView.ZYMC : ''}
                            </div>
                        </div>
                        <div>
                            <span styleName="item-label">班级：</span>
                            <div
                                className="t-clamp-1"
                                styleName="item-name"
                                style={{ display: 'inline' }}
                            >
                                {formInitData.jbxxView ? formInitData.jbxxView.BJMC : ''}
                            </div>
                        </div>
                    </Flex.Item>
                </Flex>
                <div className="p-sw">
                    <div>
                        <NHFormItem id={'kzxx.cym'}
                            label={'曾用名'}
                            form={form}
                            formItemLayout={formItemLayout}
                            initialValue={(formInitData.kzxx || {}).cym}
                        >
                            <Input maxLength={8} placeholder="请填写曾用名" />
                        </NHFormItem>
                    </div>
                    <div>
                        <NHFormItem id={'jbxx.mzm'}
                            label={'民族'}
                            form={form}
                            required={true}
                            formItemLayout={formItemLayout}
                            initialValue={(formInitData.jbxx || {}).mzm}
                        >
                            <NHSelect sign='DMK_XTGL_MZM' />
                        </NHFormItem>
                    </div>
                    <div>
                        <NHFormItem id={'jbxx.zzmmm'}
                            label={'政治面貌'}
                            form={form}
                            required={true}
                            formItemLayout={formItemLayout}
                            initialValue={(formInitData.jbxx || {}).zzmmm}
                        >
                            <NHSelect sign='ZHXG_ZZMMM' />
                        </NHFormItem>
                    </div>
                    <div>
                        <NHFormItem id={'jbxx.jgmArray'}
                            label={'籍贯'}
                            form={form}
                            required={true}
                            formItemLayout={formItemLayout}
                            // hasFeedback={true}
                            // pattern={FormRules.MOBILE_PHONE_NUMBER}
                            initialValue={(formInitData.jbxx || {}).jgmArray}
                        >
                            <NHCascader sign={"zhxg_ssq"} onChange={(value, selectedOptions) => this.onNHCascaderChange(value, selectedOptions, 'jg')} />
                        </NHFormItem>
                    </div>
                    <div>
                        <Form.Item label='身高' {...formItemLayout}>
                            <Input.Group compact>
                                {getFieldDecorator('tjxx.sg',{
                                    initialValue:(formInitData.tjxx || {}).sg,
                                    rules:[
                                        { required:true, message:'身高不能为空' }
                                    ]
                                })(<InputNumber min={50} max={300} />)}
                                <span style={{lineHeight:2,marginLeft:5}}>cm</span>
                            </Input.Group>
                            
                        </Form.Item>
                    </div>
                    <div>
                        <NHFormItem id={'lxxx.sjhm'}
                            label={'本人电话'}
                            form={form}
                            formItemLayout={formItemLayout}
                            required={true}
                            // hasFeedback={true}
                            // pattern={FormRules.MOBILE_PHONE_NUMBER}
                            initialValue={(formInitData.lxxx || {}).sjhm}
                        >
                            <Input maxLength={11} placeholder="请填写本人电话" />
                        </NHFormItem>
                    </div>
                    <div>
                        <Form.Item label='家庭电话' {...formItemLayout} style={{marginBottom:0}}>
                            <Row>
                                <Col span={10}>
                                    <Form.Item>
                                        {getFieldDecorator('jtxx.jtdhqh',{
                                            initialValue:(formInitData.jtxx || {}).jtdhqh,
                                            rules:[
                                                {
                                                    pattern: /[\d]+$/, message: "区号只能是数字"
                                                }
                                            ]
                                        })(<Input maxLength={4} placeholder='区号'/>)}
                                    </Form.Item>
                                </Col>
                                <Col span={1} offset={1} >-</Col>
                                <Col span={12}>
                                    <Form.Item>
                                        {getFieldDecorator('jtxx.jtdhhm',{
                                            initialValue:(formInitData.jtxx || {}).jtdhhm,
                                            rules:[
                                                {
                                                    pattern: /[\d]+$/, message: "电话号码只能是数字"
                                                }
                                            ]
                                        })(<Input maxLength={8} placeholder='电话号码'/>)}
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Form.Item>
                    </div>
                    <div>
                        <NHFormItem id={'lxxx.dzyx'}
                            label={'E-mail'}
                            form={form}
                            // required={true}
                            formItemLayout={formItemLayout}
                            // hasFeedback={true}
                            pattern={{ pattern: /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/, message: "请输入正确的邮箱地址" }}
                            initialValue={(formInitData.lxxx || {}).dzyx}
                        >
                            <Input maxLength={50} placeholder="请填写E-mail" />
                        </NHFormItem>
                    </div>
                    <div>
                        <NHFormItem id={'lxxx.wx'}
                            label={'微信号'}
                            form={form}
                            formItemLayout={formItemLayout}
                            // hasFeedback={true} /^[a-zA-Z][a-zA-Z\d_-]{5,19}$/
                            //pattern={{ pattern: /^[a-zA-Z][a-zA-Z\d_-]{5,19}$/, message: "请输入正确的微信号" }}
                            initialValue={(formInitData.lxxx || {}).wx}
                        >
                            <Input maxLength={20} placeholder="请填写微信号" />
                        </NHFormItem>
                    </div>
                    <div>
                        <NHFormItem id={'lxxx.qq'}
                            label={'QQ号'}
                            form={form}
                            formItemLayout={formItemLayout}
                            // hasFeedback={true}
                            pattern={{ pattern: /[\d]+$/, message: "请输入正确的QQ号" }}
                            initialValue={(formInitData.lxxx || {}).qq}
                        >
                            <Input maxLength={15} placeholder="请填写QQ号" />
                        </NHFormItem>
                    </div>
                    <div>
                        <NHFormItem id={'jbxx.sfzjh'}
                            label={'身份证件号'}
                            form={form}
                            formItemLayout={formItemLayout}
                            // hasFeedback={true}
                            // pattern={FormRules.MOBILE_PHONE_NUMBER}
                            initialValue={(formInitData.jbxx || {}).sfzjh}
                        >
                            <Input disabled />
                        </NHFormItem>
                    </div>
                    <div>
                        <NHFormItem id={'jbxx.sfzqfjg'}
                            label={'身份证签发机关'}
                            form={form}
                            required={true}
                            formItemLayout={formItemLayout}
                            // hasFeedback={true}
                            // pattern={FormRules.MOBILE_PHONE_NUMBER}
                            initialValue={(formInitData.jbxx || {}).sfzqfjg}
                        >
                            <Input maxLength={30} placeholder="请填写身份证签发机关" />
                        </NHFormItem>
                    </div>
                    <div>
                        <NHFormItem id={'jbxx.sfzyxq'}
                            label={'身份证有效期'}
                            form={form}
                            required={true}
                            formItemLayout={formItemLayout}
                            // hasFeedback={true}
                            // pattern={FormRules.MOBILE_PHONE_NUMBER}
                            initialValue={(formInitData.jbxx || {}).sfzyxq}
                        >
                            <RangePicker />
                        </NHFormItem>
                    </div>
                    <div>
                        <NHFormItem id={'jbxx.sfzzz'}
                            label={'身份证住址'}
                            form={form}
                            required={true}
                            formItemLayout={formItemLayout}
                            // hasFeedback={true}
                            // pattern={FormRules.MOBILE_PHONE_NUMBER}
                            initialValue={(formInitData.jbxx || {}).sfzzz}
                        >
                            <Input maxLength={150} placeholder="请填写身份证住址" />
                        </NHFormItem>
                    </div>
                    <div>
                        <Form.Item
                            label={'家庭住址'}
                            {...formItemLayout}
                            style={{marginBottom:0}}
                            required={true}
                        >
                            <Form.Item style={{marginBottom:0}}>
                                    {getFieldDecorator('jtxx.jtszdqArray',{initialValue:(formInitData.jtxx || {}).jtszdqArray,rules: [{ required: true, message: '请填写家庭地址' }]})(<NHCascader style={{width:585.33}} sign={"zhxg_ssq"} onChange={(value, selectedOptions) => this.onNHCascaderChange(value, selectedOptions, 'jt')}/>)}
                            </Form.Item>
                            <Form.Item>
                                    {getFieldDecorator('jtxx.jtjddz',{initialValue:(formInitData.jtxx || {}).jtjddz,rules: [{ required: true, message: '请填写家庭街道地址' }]})(<Input maxLength={50} placeholder="请填写家庭地址，如：xx街道、xx小区、门牌号" />)}
                            </Form.Item>
                        </Form.Item>
                    </div>
                    <div>
                        <NHFormItem id={'kzxx.grtc'}
                            label={'爱好/特长'}
                            required={true}
                            form={form}
                            formItemLayout={formItemLayout}
                            initialValue={(formInitData.kzxx || {}).grtc}
                        >
                            <Input maxLength={300} />
                        </NHFormItem>
                    </div>
                </div>
                </React.Fragment>
            );
        }
        return (
  
            <Form>
                <TitleTop
                    title="基本信息"
                    onEdit={type => {
                        this.setState({
                            jbxx: true
                        });
                        // getChildComponent(1, false);
                    }}
                    onSave={cb => {
                        this.onSavejbxxFormData(cb);
                        // getChildComponent(1, true);
                    }}
                    onClose={() => {
                        this.setState({
                            jbxx: false
                        });
                    }}
                />
                {jbxx ? renderEdit():renderView()}
            </Form>
        );
    }
}


const JbxxForm = Form.create()(JbxxInitForm);

export default JbxxForm;


// WEBPACK FOOTER //
// ./app/pages/SelfHelp/updateInfo/JbxxForm.js